import React, { useState, useEffect } from 'react';
import Loader from '../../atoms/loader';
import { Line } from 'react-chartjs-2';
import RangeSelector from '../../atoms/range-slider';
import { BQLink } from '../../atoms/bqlink';
import { QueryClient, QueryClientProvider, useQuery } from 'react-query';
import { ArrowRightIcon, ListBoxOutlineIcon } from '../../atoms/material-icons';
import { isEmpty } from 'lodash';
import EmptyState from '../empty-state';
import './indian-indices.m.css';

const IndianIndices = () => {
  const [indianIndicesData, setIndianIndicesData] = useState([]);
  const [indicesDetails, setIndicesDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const [selectedDuration, setSelectedDuration] = useState('');
  const [oneD, setOneD] = useState(false);
  const [oneW, setOneW] = useState(false);
  const [oneM, setOneM] = useState(false);
  const [oneYTD, setOneYTD] = useState(false);
  const [oneY, setOneY] = useState(false);
  const [threeY, setThreeY] = useState(false);
  const [toggle, setToggle] = useState(-1);
  const [selectedKey, setSelectedKey] = useState('');
  const [initialLoading, setInitialLoading] = useState(true);

  const queryClient = new QueryClient();

  const getIndianIndicesData = async (duration = '1D') => {
    const response = await fetch(`/feapi/markets/indices/indian-indices/${duration || '1D'}`);
    return response.json();
  };

  const getIndicesDetailsData = async (key = '1', duration = '1D') => {
    const response = await fetch(
      `/feapi/markets/indices/${key || '1'}/details/${duration || '1D'}`
    );
    return response.json();
  };

  const resultIndianIndices = useQuery(
    'getIndianIndicesData',
    () => getIndianIndicesData(selectedDuration),
    {
      refetchInterval: 30000,
      refetchIntervalInBackground: true,
      onSuccess: (data) => {
        setIndianIndicesData(data.data);
      },
    }
  );

  const resultIndianIndicesDetails = useQuery(
    'getIndianIndicesDetailsData',
    () => getIndicesDetailsData(selectedKey, selectedDuration),
    {
      refetchInterval: 30000,
      refetchIntervalInBackground: true,
      onSuccess: (data) => {
        setIndicesDetails(data.data);
      },
    }
  );

  useEffect(() => {
    const getIndianIndicesData = async () => {
      const response = await fetch('/feapi/markets/indices/indian-indices/1D');
      const data = await response.json();
      setIndianIndicesData(data.data);
    };

    const getIndicesDetailsData = async () => {
      const response = await fetch('/feapi/markets/indices/1/details/1D');
      const data = await response.json();
      setIndicesDetails(data.data);
    };

    getIndianIndicesData();
    getIndicesDetailsData();
  }, []);

  useEffect(() => {
    setSelectedDuration('1D');
    setSelectedKey('1');
    if (resultIndianIndices?.isSuccess) {
      setIndianIndicesData(resultIndianIndices?.data?.data);
    }

    if (resultIndianIndicesDetails?.isSuccess) {
      setIndicesDetails(resultIndianIndicesDetails?.data?.data);
    }

    setOneD(true);
    setOneW(false);
    setOneM(false);
    setOneYTD(false);
    setOneY(false);
    setThreeY(false);
    setToggle(0);
  }, []);

  const durationHandler = async (duration) => {
    setLoading(true);
    const response = await fetch(`/feapi/markets/indices/indian-indices/${duration}`);
    const data = await response.json();
    setIndianIndicesData(data.data);
    setLoading(false);
  };

  const options = {
    animation: false,
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
    },
    elements: {
      point: {
        radius: 0,
      },
    },
    scales: {
      x: {
        ticks: {
          display: false,
        },
        grid: {
          drawBorder: false,
          display: false,
        },
      },
      y: {
        ticks: {
          display: false,
        },
        grid: {
          drawBorder: false,
          display: false,
        },
      },
    },
    interaction: {
      mode: 'nearest',
      axis: 'x',
      intersect: false,
    },
  };

  const requiredLabels =
    indicesDetails &&
    indicesDetails?.graph?.map((value) => {
      return value[0];
    });

  const dataGraph = {
    labels: requiredLabels,
    datasets: [
      {
        fill: true,
        label: '',
        data:
          indicesDetails &&
          indicesDetails?.graph?.map((value) => {
            return value[1];
          }),
        borderColor: '#14c588',
        backgroundColor: '#14c588',
      },
    ],
  };

  const fetchIndiceDetailsHandler = async (key, duration, index) => {
    try {
      setLoading(true);
      const response = await fetch(
        `/feapi/markets/indices/${key || '1'}/details/${duration || '1D'}`
      );
      const data = await response.json();
      setIndicesDetails(data.data);
      setLoading(false);
      setToggle(index);
    } catch (error) {
      console.log('Error Fetching Indice details', error);
    }
  };

  const total = indicesDetails?.highlights?.declines + indicesDetails?.highlights?.advances;

  if (resultIndianIndices?.isLoading || resultIndianIndicesDetails?.isLoading) {
    <div>
      <Loader color={'#dadee1'} />
    </div>;
  }

  if (initialLoading) {
    return <div styleName="initial-loading-container"></div>;
  }

  return (
    <QueryClientProvider client={queryClient}>
      {indianIndicesData?.length === 0 || isEmpty(indicesDetails) ? (
        <div styleName="no-content-outermost">
          <div styleName="header-title-container">
            <ListBoxOutlineIcon size={'26px'} color={'#d01e51'} />
            <h4 styleName="list-header-title">Indices</h4>
          </div>
          <div styleName="no-data-container-ext">
            <div styleName="no-data-container-int">
              <EmptyState />
            </div>
          </div>
        </div>
      ) : (
        <div styleName="indian-indices-container">
          <div styleName="indian-ind-left">
            <div styleName="header-title-container">
              <ListBoxOutlineIcon size={'26px'} color={'#d01e51'} />
              <h4 styleName="list-header-title">Indices</h4>
            </div>
            <div styleName="btn-container">
              <button
                styleName={`filter-btn ${oneD ? 'selected' : ' '} `}
                onClick={() => {
                  durationHandler('1D');
                  setSelectedDuration('1D');
                  fetchIndiceDetailsHandler(indianIndicesData && indianIndicesData[0].id, '1D', 0);
                  setOneD(true);
                  setOneW(false);
                  setOneM(false);
                  setOneYTD(false);
                  setOneY(false);
                  setThreeY(false);
                }}
              >
                1D
              </button>
              <button
                styleName={`filter-btn ${oneW ? 'selected' : ' '} `}
                onClick={() => {
                  durationHandler('1W');
                  fetchIndiceDetailsHandler(indianIndicesData && indianIndicesData[0].id, '1W', 0);
                  setSelectedDuration('1W');
                  setOneD(false);
                  setOneW(true);
                  setOneM(false);
                  setOneYTD(false);
                  setOneY(false);
                  setThreeY(false);
                }}
              >
                1W
              </button>
              <button
                styleName={`filter-btn ${oneM ? 'selected' : ' '} `}
                onClick={() => {
                  durationHandler('1M');
                  fetchIndiceDetailsHandler(indianIndicesData && indianIndicesData[0].id, '1M', 0);
                  setSelectedDuration('1M');
                  setOneD(false);
                  setOneW(false);
                  setOneM(true);
                  setOneYTD(false);
                  setOneY(false);
                  setThreeY(false);
                }}
              >
                1M
              </button>
              <button
                styleName={`filter-btn ${oneYTD ? 'selected' : ' '} `}
                onClick={() => {
                  durationHandler('YTD');
                  fetchIndiceDetailsHandler(indianIndicesData && indianIndicesData[0].id, 'YTD', 0);
                  setSelectedDuration('YTD');
                  setOneD(false);
                  setOneW(false);
                  setOneM(false);
                  setOneYTD(true);
                  setOneY(false);
                  setThreeY(false);
                }}
              >
                YTD
              </button>
              <button
                styleName={`filter-btn ${oneY ? 'selected' : ' '} `}
                onClick={() => {
                  durationHandler('1Y');
                  setSelectedDuration('1Y');
                  fetchIndiceDetailsHandler(indianIndicesData && indianIndicesData[0].id, '1Y', 0);
                  setOneD(false);
                  setOneW(false);
                  setOneM(false);
                  setOneYTD(false);
                  setOneY(true);
                  setThreeY(false);
                }}
              >
                1Y
              </button>
              <button
                styleName={`filter-btn ${threeY ? 'selected' : ' '} `}
                onClick={() => {
                  durationHandler('3Y');
                  setSelectedDuration('3Y');
                  fetchIndiceDetailsHandler(indianIndicesData && indianIndicesData[0].id, '3Y', 0);
                  setOneD(false);
                  setOneW(false);
                  setOneM(false);
                  setOneYTD(false);
                  setOneY(false);
                  setThreeY(true);
                }}
              >
                3Y
              </button>
            </div>
            {loading ? (
              <div styleName="loader-container">
                <Loader color={'#dadee1'} />
              </div>
            ) : (
              <div styleName="stats-outer-container">
                {indianIndicesData.map((indice, index) => (
                  <div
                    styleName={`stats-container ${index === toggle ? 'selected-filter' : ''}`}
                    key={indice.id}
                    onClick={() => {
                      setSelectedKey(indice.id);
                      fetchIndiceDetailsHandler(indice.id, selectedDuration, index);
                    }}
                  >
                    <div styleName="stats-one">
                      <p styleName="value-desc">{indice.name}</p>
                      {String(indice['price-movement'].chg).includes('-') ? (
                        <span styleName="negative-value">{indice['price-movement'].chg}</span>
                      ) : (
                        <span styleName="positive-value">+{indice['price-movement'].chg}</span>
                      )}
                    </div>

                    <div styleName="stats-two">
                      <p styleName="value-stat">{indice['price-movement']['current-price']}</p>
                      {String(indice['price-movement'].chgp).includes('-') ? (
                        <span styleName="negative-value">
                          &#9660;{indice['price-movement'].chgp}%
                        </span>
                      ) : (
                        <span styleName="positive-value">
                          &#9650;+{indice['price-movement'].chgp}%
                        </span>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
            <div styleName="view-btn-container">
              <BQLink
                styleName="view-all-ind"
                href="/markets/equities/all"
                target="_blank"
                rel="noreferrer"
              >
                View All Indices <ArrowRightIcon color={'#2b2b2b'} styleName="tab-icon" />
              </BQLink>
            </div>
          </div>
          {loading ? (
            <div styleName="indian-ind-right loader-container">
              <Loader color={'#dadee1'} />
            </div>
          ) : (
            <div styleName="indian-ind-right">
              <div styleName="overall-stats">
                <div styleName="top-stats-container-one">
                  <p styleName="top-stat-title">Top Gainer</p>
                  {indicesDetails?.highlights?.topgainer?.name ? (
                    <BQLink
                      href={`/stock/${indicesDetails?.highlights?.topgainer?.sid
                        }/${indicesDetails?.highlights?.topgainer?.name
                          ?.toLowerCase()
                          .trim()
                          .replaceAll(' ', '-')
                          .split('-')
                          .filter((val) => val !== '')
                          .map((val) => val.replaceAll('.', ''))
                          .join('-')}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <p styleName="top-stat-name">{indicesDetails?.highlights?.topgainer?.name}</p>
                    </BQLink>
                  ) : (
                    <p styleName="top-stat-name">No Gainers</p>
                  )}

                  {indicesDetails?.highlights?.topgainer?.chgp ? (
                    <p styleName="top-stat-positive">
                      &#9650;+{indicesDetails?.highlights?.topgainer?.chgp}%
                    </p>
                  ) : (
                    <p styleName="top-stat-positive">-</p>
                  )}
                </div>
                <div styleName="top-stats-container-two">
                  <p styleName="top-stat-title">Top Loser</p>
                  {indicesDetails?.highlights?.toploser?.name ? (
                    <BQLink
                      href={`/stock/${indicesDetails?.highlights?.toploser?.sid
                        }/${indicesDetails?.highlights?.toploser?.name
                          ?.toLowerCase()
                          .trim()
                          .replaceAll(' ', '-')
                          .split('-')
                          .filter((val) => val !== '')
                          .map((val) => val.replaceAll('.', ''))
                          .join('-')}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <p styleName="top-stat-name">{indicesDetails?.highlights?.toploser?.name}</p>
                    </BQLink>
                  ) : (
                    <p styleName="top-stat-name">No Losers</p>
                  )}
                  {indicesDetails?.highlights?.toploser?.chgp ? (
                    <p styleName="top-stat-negative">
                      &#9660;{indicesDetails?.highlights?.toploser?.chgp}%
                    </p>
                  ) : (
                    <p styleName="top-stat-negative">-</p>
                  )}
                </div>
              </div>

              <div styleName="range-slider-container">
                <RangeSelector
                  min={indicesDetails['high-low'] && indicesDetails['high-low']?.low}
                  max={indicesDetails['high-low'] && indicesDetails['high-low']?.high}
                  currentValue={indicesDetails && indicesDetails['high-low']?.currentprice}
                  label=""
                />

                <RangeSelector
                  min={indicesDetails['high-low'] && indicesDetails['high-low']['52-week-low']}
                  max={indicesDetails['high-low'] && indicesDetails['high-low']['52-week-high']}
                  currentValue={indicesDetails && indicesDetails['high-low']?.currentprice}
                  label=""
                  labelOne="52 Week Low"
                  labelTwo="52 Week High"
                />
              </div>
              <div styleName="graph-container">
                {indicesDetails?.graph?.length !== 0 ? (
                  <Line options={options} data={dataGraph} width={'100%'} height={'60%'} />
                ) : (
                  <div styleName="no-data-container-ext-alt">
                    <div styleName="no-data-container-int">
                      <EmptyState />
                    </div>
                  </div>
                )}
              </div>
              {indicesDetails?.highlights?.advances || indicesDetails?.highlights?.declines ? (
                <>
                  <div styleName="adv-dec-details">
                    <span>{indicesDetails?.highlights?.advances}</span>
                    <span>{indicesDetails?.highlights?.declines}</span>
                  </div>
                  <div styleName="adv-dec-container">
                    <div
                      styleName="adv-bar"
                      style={{ width: `${(indicesDetails?.highlights?.advances / total) * 100}%` }}
                    />
                  </div>
                  <div styleName="adv-dec-titles">
                    <span>Advances</span>
                    <span>Declines</span>
                  </div>
                </>
              ) : (
                <div styleName="no-advances-declines">
                  <span>Advances/Declines data not available at the moment.</span>
                </div>
              )}

              <div styleName="bottom-stats-container">
                {indicesDetails['historical-returns'] &&
                  indicesDetails['historical-returns']?.map((value, index) => (
                    <div key={index} styleName="label-stat-container">
                      <span styleName="value-label">{value.label}</span>

                      {String(value.change).includes('-') ? (
                        <span styleName="value-stat-negative">-{Math.abs(value.change)}%</span>
                      ) : (
                        <span styleName="value-stat-positive">{value.change}%</span>
                      )}
                    </div>
                  ))}
              </div>
              <div styleName="ext-btn-container">
                <BQLink
                  styleName="ext-btn"
                  href="/markets/equities/stocks-in-indices"
                  target="_blank"
                  rel="noreferrer"
                >
                  Stocks in SENSEX
                </BQLink>
                <BQLink
                  styleName="ext-btn"
                  href="/markets/equities/historical-returns"
                  target="_blank"
                  rel="noreferrer"
                >
                  Historical Returns
                </BQLink>
              </div>
            </div>
          )}
        </div>
      )}
    </QueryClientProvider>
  );
};

export { IndianIndices };
